export { default as SearchResultSubScreen } from "./SearchResultSubScreen";
